import { useGetAllTasks } from './use-get-all-tasks';
import { useProjectTemplateTask } from './use-task';
const findProjectPhase = (allTasks, task)=>{
    var _task_parentTask;
    if (!task) {
        return undefined;
    }
    if (task === null || task === void 0 ? void 0 : task.projectPhase) {
        return task === null || task === void 0 ? void 0 : task.projectPhase;
    }
    return findProjectPhase(allTasks, allTasks[task === null || task === void 0 ? void 0 : (_task_parentTask = task.parentTask) === null || _task_parentTask === void 0 ? void 0 : _task_parentTask.taskId]);
};
export const useGetProjectPhaseOfTask = (taskId)=>{
    const allTasks = useGetAllTasks();
    const task = useProjectTemplateTask(taskId);
    return task && findProjectPhase(allTasks, task);
};
